import { ContentDataBlockTable } from '@amf/shared/components/content/Content';

interface TableProps {
  block: ContentDataBlockTable;
}

export default function Table({ block }: TableProps) {
  return (
    <table>
      <tbody>
        {block.data.content.map((columns, key) => (
          <tr key={key}>
            {columns.map((row, key) => (
              <td key={key} dangerouslySetInnerHTML={{ __html: row }} />
            ))}
          </tr>
        ))}
      </tbody>
    </table>
  );
}
